const PHONE = '390px';
const TABLET = '744px';
const DESKTOP = '940px';
const MAX_WIDTH = '872px';

export { PHONE, TABLET, DESKTOP, MAX_WIDTH };
